import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllDispensationService = async (
  pageNumber,
  pageSize,
  access_token,
  debouncedSearch = ""
) => {
  try {
    const filter = {
      visitName: debouncedSearch,
      treatmentName: debouncedSearch,
    };
    return axios.get(
      `${api}/Dispensation/GetDispensationDataPagination?pageNumber=${
        debouncedSearch !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&filter=${JSON.stringify(filter)}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const createDispensationService = async (access_token, data) => {
  try {
    return axios.post(`${api}/Dispensation/Create`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchDispensationByIdService = async (access_token, id) => {
  try {
    return axios.get(`${api}/Dispensation/GetById?Id=${id}`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateDispensationService = async (access_token, data, id) => {
  try {
    return axios.post(`${api}/Dispensation/Update?Id=${id}`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const loadDispensationDataService = async (access_token) => {
  try {
    return axios.get(`${api}/Dispensation/GetCreateOnloadData`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchAllDispensationDetailsService = async (
  access_token,
  id,
  pageNumber,
  pageSize,
  debouncedSearch = ""
) => {
  try {
    const filter = {
      doseLevelName: debouncedSearch,
      drugTypeName: debouncedSearch,
      quantity: debouncedSearch,
    };
    return axios.get(
      `${api}/DispensationDetail/GetDispensationDetailPagination?DispensationId=${id}&pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${JSON.stringify(
        filter
      )}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const fetchLoadingDataForDispensationDetailService = async (
  access_token,
  id
) => {
  try {
    return axios.get(
      `${api}/DispensationDetail/GetCreateOnloadData?DispensationId=${id}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const createDispensationDetailService = async (access_token, data) => {
  try {
    return axios.post(`${api}/DispensationDetail/Create`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const deleteDispensationDetailService = async (access_token, id) => {
  try {
    return axios.get(
      `${api}/DispensationDetail/RemoveDispensationDetail?DispensationDetailId=${id}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};
